import { Suspense, lazy } from "react";
import { Route, Routes } from "react-router";

const DnsLoading = lazy(() =>
  import("./pages/dns-loading").then((module) => ({
    default: module.DnsLoading,
  }))
);
const Home = lazy(() =>
  import("./pages/home").then((module) => ({ default: module.Home }))
);
const Privacy = lazy(() =>
  import("./pages/privacy").then((module) => ({ default: module.Privacy }))
);
const Success = lazy(() =>
  import("./pages/success").then((module) => ({ default: module.Success }))
);
const FaqPage = lazy(() =>
  import("./pages/faq").then((module) => ({ default: module.FaqPage }))
);
const LoginPage = lazy(() =>
    import("./pages/login").then((module) => ({ default: module.LoginPage }))
);

const MigrateLicense = lazy(() =>
  import("./pages/migrate-license").then((module) => ({
    default: module.MigrateLicense,
  }))
);
const FreeDns = lazy(() =>
    import("./pages/free-dns").then((module) => ({
        default: module.FreeDns,
    }))
);
const MigrateLicenseSuccess = lazy(() =>
  import("./pages/migrate-license-success").then((module) => ({
    default: module.MigrateLicenseSuccess,
  }))
);

const LoadingFallback = () => (
  <div className="w-full h-screen flex items-center justify-center bg-[#0D0D0D]">
    <img src="/loading.gif" alt="loading" />
  </div>
);

export const AppRoutes: React.FC = () => {
  return (
    <Suspense fallback={<LoadingFallback />}>
      <Routes>
        <Route index element={<Home />} />

        <Route path="dns-loading" element={<DnsLoading />} />

        <Route path="politica-de-privacidade" element={<Privacy />} />
        <Route path="sucesso" element={<Success />} />
        <Route path="faq" element={<FaqPage />} />

        <Route path="migrar-licenca">
          <Route index element={<MigrateLicense />} />
          <Route path="sucesso" element={<MigrateLicenseSuccess />} />
        </Route>

        <Route path="free-dns" element={<FreeDns />} />

        <Route path="login" element={<LoginPage />} />
      </Routes>
    </Suspense>
  );
};
